import { useEffect, useImperativeHandle, useRef, forwardRef } from 'react';
import { fabric } from 'fabric';

const ImageFinerCanvas = forwardRef((props, ref) => {
    const canvasElRef = useRef(null)
    const overlayElRef = useRef(null)
    const fabricCanvasRef = useRef(null)
    const overlayCanvasRef = useRef(null)

    const loadCanvasImage = (targetCanvas, imageUrl) => {
        if (!targetCanvas || !imageUrl) return
        fabric.Image.fromURL(imageUrl, (img) => {
            img.scale(props.displayScale)
            targetCanvas.setBackgroundImage(img, () => {
                targetCanvas.renderAll()
            })
        }, { crossOrigin: 'anonymous' })
    }

    useImperativeHandle(ref, () => ({
        updateResult: (imageUrl) => {
            loadCanvasImage(fabricCanvasRef.current, imageUrl || props.orignPic)
        }
    }))

    useEffect(() => {
        if (!canvasElRef.current || !overlayElRef.current) return

        const canvas = new fabric.Canvas(canvasElRef.current, {
            width: props.reswidth,
            height: props.resheight,
            selection: false,
        })
        const overlayCanvas = new fabric.Canvas(overlayElRef.current, {
            width: props.reswidth,
            height: props.resheight,
            selection: false,
            backgroundColor: 'rgba(0,0,0,0)',
        })
        overlayCanvas.upperCanvasEl.style.pointerEvents = 'none'
        overlayCanvas.lowerCanvasEl.style.pointerEvents = 'none'
        overlayCanvas.wrapperEl.style.pointerEvents = 'none'

        fabricCanvasRef.current = canvas
        overlayCanvasRef.current = overlayCanvas
        props.getCanvasRefsFun?.(canvas, overlayCanvas)
        loadCanvasImage(canvas, props.orignPic)

        return () => {
            props.getCanvasRefsFun?.(null, null)
            overlayCanvas.dispose()
            canvas.dispose()
            overlayCanvasRef.current = null
            fabricCanvasRef.current = null
        }
    }, [])

    useEffect(() => {
        if (!fabricCanvasRef.current) return
        fabricCanvasRef.current.setWidth(props.reswidth)
        fabricCanvasRef.current.setHeight(props.resheight)
        overlayCanvasRef.current?.setWidth(props.reswidth)
        overlayCanvasRef.current?.setHeight(props.resheight)
        loadCanvasImage(fabricCanvasRef.current, props.resultImage || props.orignPic)
    }, [props.reswidth, props.resheight, props.displayScale, props.orignPic, props.resultImage])

    return (
        <div style={{ position: 'relative', width: props.reswidth, height: props.resheight, opacity: props.opacity ?? 1 }}>
            <canvas
                ref={canvasElRef}
                width={props.reswidth}
                height={props.resheight}
                style={{ position: 'absolute', left: 0, top: 0, zIndex: 1 }}
            />
            <canvas
                ref={overlayElRef}
                width={props.reswidth}
                height={props.resheight}
                style={{ position: 'absolute', left: 0, top: 0, zIndex: 2 }}
            />
        </div>
    )
})

export default ImageFinerCanvas
